import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "@emotion/styled"
import { GoHeart } from "react-icons/go"
import { IconContext } from "react-icons";

const ContactHeader = styled.h1`
    font-size: 3rem;
    text-align: center;
    margin: 0;

    @media (max-width: 360px) {
        margin-top: 5rem;
    }
`

const ContactTagline = styled.p`
    font-size: 1.25rem;
    text-align: center;
    margin-bottom: 0.75rem;

    @media (max-width: 425px) {
        font-size: 1.2rem;
        margin-top: 0.25rem;
    }
`

const ContactSubTagline = styled.p`
    text-align: center;
`

const PopOfColor = styled.span`
  color: #f80c16;
`

export default () => (
    <Layout>
        <SEO title="Contact" />
        <IconContext.Provider value={{ className: "contact-icons" }}>
        <ContactHeader>Contact Me<PopOfColor>.</PopOfColor></ContactHeader>
        <ContactTagline>Want my help or just want to say hello?  I'd <GoHeart /> to help!</ContactTagline>
        <ContactSubTagline>(In the words of Emperor Palpatine... <b>DO IT!</b>)</ContactSubTagline>
        <form name="contact" method="POST" netlify-honeypot="bot-field" data-netlify="true">
            <input type="hidden" name="form-name" value="contact" />
            <input type="text" name="name" placeholder="Name" />
            <input type="email" name="email" placeholder="Email" />
            <textarea name="message" placeholder="Message"></textarea>
            <input type="submit" value="Submit"></input>
        </form>
        </IconContext.Provider>
    </Layout>
)